export type BookingServiceType = 'video' | 'home' | 'clinic';

/**
 * Resolve modalidade a partir dos campos da consulta (type legado + appointmentType).
 */
export function resolveServiceTypeFromAppointment(apt: {
  type?: string | null;
  appointmentType?: string | null;
}): BookingServiceType | null {
  if (apt.type === 'home' || apt.type === 'video' || apt.type === 'clinic') {
    return apt.type;
  }
  if (apt.appointmentType === 'DOMICILIAR') return 'home';
  if (apt.appointmentType === 'TELEMEDICINA') return 'video';
  if (apt.appointmentType === 'CONSULTORIO') return 'clinic';
  return null;
}
